// EditStudent Component for update student data

// Import Modules
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientKulawruttaForm from "../Forms/PatientKulawruttaForm";
import CONFIG from "../../config";
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";
import { useTheme } from "../../context/ThemeContext";

// EditStudent Component
const EditPatientKulawrutta = () => {
  const { markSectionComplete } = useOutletContext();
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, selectedCase, doctorInfo } =
    usePatient();
  const { theme } = useTheme();
  const { patientId, caseId, visitId } = useParams();
  const location = useLocation();

  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  //onSubmit handler
  const onSubmitHandler = (updatedPatientKulawrutta, options = {}) => {
    const isAutoSave = options?.isAutoSave;
    console.log("patient data after submit:", updatedPatientKulawrutta); // Log the data to be updated

    //  const updatedData = {
    //   ...patientData,
    //   patientKulawrutta: [{ ...updatedPatientKulawrutta }] // Overwrite patientInfo while keeping other data unchanged
    // };

    // const updatedData = {
    //   ...patientData,
    //   patientKulawrutta: patientData.patientKulawrutta.map(info => ({
    //       ...info, // Keep existing patientInfo fields
    //       ...updatedPatientKulawrutta // Merge updated fields
    //   }))
    // };

    // const updatedData = {
    //   ...patientData,
    //   patientKulawrutta: patientData.patientKulawrutta.length > 0
    //       ? patientData.patientKulawrutta.map(info => ({
    //           ...info, // Keep existing patientInfo fields
    //           ...updatedPatientKulawrutta // Merge updated fields
    //       }))
    //       : [updatedPatientKulawrutta] // If empty, create a new array with updatedPatientKulawrutta
    // };

    const updatedData = {
      ...patientData,
      patientKulawrutta:
        patientData?.patientKulawrutta?.length > 0
          ? patientData.patientKulawrutta.map((info) => ({
            ...info, // Keep existing patientInfo fields
            ...updatedPatientKulawrutta, // Merge updated fields
            PATIENT_ID: patientData.PATIENT_ID,
            CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
            //          VISIT_ID: selectedVisit || visitId  // Add VISIT_ID if missing
            DOCTOR_ID: doctorInfo.MANDALI_ID,
            CLINIC_ID: doctorInfo.CLINIC_ID, // Merge updated fields
          }))
          : [
            {
              ...updatedPatientKulawrutta,
              PATIENT_ID: patientData.PATIENT_ID,
              CASE_ID: selectedCase || caseId, // Default CASE_ID if not provided
              //         VISIT_ID: selectedVisit || visitId // Default VISIT_ID if not provided
              DOCTOR_ID: doctorInfo.MANDALI_ID,
              CLINIC_ID: doctorInfo.CLINIC_ID, // Merge updated fields
            },
          ],
    };

    setPatientData(updatedData);
    markSectionComplete("kulawrutta");
    if (!isAutoSave) {
      if (location.pathname.startsWith("/addpatient")) {
        navigate("/addpatient/tapasanya");
      } else if (location.pathname.startsWith("/visits")) {
        navigate(`/visits/${patientId}/${caseId}/${visitId}/tapasanya`);
      } else {
        console.warn("Unknown route, no redirection");
      }
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-10">
        <h3
          className="text-2xl md:text-4xl mb-3 tracking-tight"
          style={{
            fontFamily: theme.fonts?.serif,
            color: theme.text
          }}
        >
          Kulawrutta (Family History)
        </h3>
        <div className="h-1 w-12 rounded-full mb-6" style={{ backgroundColor: theme.primary }} />
        <p className="text-sm md:text-base opacity-60 font-medium" style={{ color: theme.textSecondary }}>
          Recording significant health events and patterns in the patient's family.
        </p>
      </div>

      {patientData && (
        <PatientKulawruttaForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          onAutoSave={(values) => onSubmitHandler(values, { isAutoSave: true })}
          enableReinitialize={true}
        />
      )}
    </div>
  );
};

export default EditPatientKulawrutta;
